/* drdorisday.com homepage video fix (Oct 11, 2026). Same approach as the dorisdaymd.com v2 loader
   (the version that fixed the iPhone "frozen video"), with one change: the hero now also plays with
   Reduce Motion switched on, as the live site does.
   - Hero (text_with_video): a poster image paints first; the video is attached after window load
     (smaller file on phones, WebM where supported) and the poster hides once it is actually playing.
   - Media Showcase (data-on-visible): only loads when scrolled within 300px, then autoplays muted/inline.
   - Never a frozen frame: if autoplay is refused (iPhone Low Power Mode) or the connection is
     Save-Data/2G/3G, the video shows its first frame with the native play button so it can be tapped.
   - Safe to include more than once. */
(function () {
  if (window.__ddDeferredVideo) return;
  window.__ddDeferredVideo = true;

  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var slow = !!(conn && (conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || '')));
  var small = !!(window.matchMedia && window.matchMedia('(max-width: 768px)').matches);

  function pickSrc(v) {
    var d = v.dataset;
    if (small && d.srcMobile) return { src: d.srcMobile, type: 'video/mp4' };
    if (d.srcWebm && v.canPlayType && v.canPlayType('video/webm; codecs="vp9"')) return { src: d.srcWebm, type: 'video/webm' };
    return { src: d.srcMp4, type: 'video/mp4' };
  }

  function showControls(v) {
    v.hidden = false;
    v.removeAttribute('aria-hidden');
    v.controls = true;
  }

  function attach(v, autoplay) {
    if (v.dataset.started) return false;
    var pick = pickSrc(v);
    if (!pick.src) return false;
    v.dataset.started = '1';
    // iOS Safari: muted + playsinline must be set as properties AND attributes before load/play.
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
    v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    if (autoplay) { v.autoplay = true; v.setAttribute('autoplay', ''); }
    v.preload = autoplay ? 'auto' : 'metadata';
    var s = document.createElement('source');
    s.src = pick.src; s.type = pick.type;
    v.appendChild(s);
    v.load();
    return true;
  }

  function tryPlay(v, onFail) {
    var p;
    try { p = v.play(); } catch (e) { onFail(); return; }
    if (p && typeof p.then === 'function') p.then(null, onFail);
  }

  function startHero(v) {
    var poster = v.parentNode && v.parentNode.querySelector('.twv_poster');
    function swapToVideo() {
      // Show the video element in the poster's place (same box, so nothing moves).
      if (poster && !v.poster) v.poster = poster.currentSrc || poster.src;
      v.hidden = false;
      v.removeAttribute('aria-hidden');
      if (poster) poster.style.display = 'none';
    }
    function offerPlay() { swapToVideo(); v.controls = true; }
    if (slow) { if (attach(v, false)) offerPlay(); return; }
    v.addEventListener('playing', swapToVideo, { once: true });
    if (!attach(v, true)) return;
    tryPlay(v, offerPlay);
    setTimeout(function () { if (v.paused && !v.controls) offerPlay(); }, 6000);
  }

  function startMedia(v) {
    if (slow) { if (attach(v, false)) showControls(v); return; }
    if (!attach(v, true)) return;
    tryPlay(v, function () { showControls(v); });
    // Safety net: if nothing is playing 4 s later, offer the play button instead of a frozen frame.
    setTimeout(function () { if (v.paused && !v.controls) showControls(v); }, 4000);
  }

  function initMedia() {
    var vids = document.querySelectorAll('video[data-deferred-video][data-on-visible]');
    Array.prototype.forEach.call(vids, function (v) {
      if (!('IntersectionObserver' in window)) { startMedia(v); return; }
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { io.disconnect(); startMedia(v); break; }
        }
      }, { rootMargin: '300px 0px' });
      io.observe(v);
    });
  }

  function initHero() {
    var vids = document.querySelectorAll('video[data-deferred-video]:not([data-on-visible])');
    Array.prototype.forEach.call(vids, startHero);
  }

  // Both start after window load: before that, lazy images have no height yet, the page is short,
  // and the Media Showcase would wrongly count as "near the screen" and download immediately.
  function afterLoad() {
    setTimeout(initMedia, 300);
    if ('requestIdleCallback' in window) requestIdleCallback(initHero, { timeout: 2000 });
    else setTimeout(initHero, 1000);
  }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad);
})();
